<template>
  <v-dialog v-model="show" max-width="800px" persistent>
    <v-card>
      <v-card-title>Modell erstellen</v-card-title>
      <v-card-subtitle v-if="file == null" style="color: red">Sie müssen eine Datei mit der Endung .bpmn auswählen um ein Prozessmodell zu importieren</v-card-subtitle>
      <v-container>
        <v-row class="mx-2">
          <v-col>
            <label>
              Datei
              <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
            </label>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col>
            <v-select
            v-model="selectedFolder"
            :items="folders"
            item-text="folderName"
            item-value="id"
            label="Ordner wählen"
            hint="Es können nur Ordner mit Schreibberechtigung gewählt werden"
            persistent-hint
          ></v-select>
          <v-switch v-model="addCharacteristic" label="Prozesssteckbrief hinzufügen"></v-switch>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-btn id="leftButton" text @click.stop="show=false">Abbrechen</v-btn>
        <v-btn id="rightButton" @click.stop="uploadProcessModel()" color="primary" :disabled="file == null || selectedFolder == null">Hochladen</v-btn>
      </v-card-actions>
    </v-card>
      <ProcessCharacteristicsDialog ref="newCharacteristics" :openFromProcess="true"/>
  </v-dialog>
</template>

<script>
import newProcessService from "./new-process-service";
import ProcessCharacteristicsDialog from '../ProcessMap/ProcessCharacteristicsDialog.vue';
import processMapService from '@/components/processMapService.js';
export default {
  props: {
    value: Boolean,
    folders: Array
  },
  components:{
    ProcessCharacteristicsDialog
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      file: null,
      selectedFolder: null,
      addCharacteristic: false,
      characteristics: null
    };
  },
  watch:{
    addCharacteristic(){
      if(this.addCharacteristic) this.openCharacteristicDialog();
    }
  },
  methods: {
    uploadProcessModel() {
      if(this.file != null){
        this.show = false;
        this.file = new File([this.file], this.file.name.replace(/\.bpmn$/, ""), { type: this.file.type });

        let formData = new FormData();
        formData.append("uploadedFile", this.file);

        const router = this.$router;

        newProcessService
        .uploadFile(formData)
        .then(result => {
          const uuid = result.data;
          this.$emit("linkProcessToFolder", {
            folderId: this.selectedFolder,
            uuid: uuid
          })
          if(this.characteristics) this.characteristics.connectedModel = uuid;
          if(this.addCharacteristic){
            processMapService.addProcessCharacteristic(this.characteristics).then(res => {
              router.push({ name: "modeling", params: {
                    isNew: true,
                    uuid: uuid
                } });
            })
          }else{
            router.push({ name: "modeling", params: {
                    isNew: true,
                    uuid: uuid
                } });
          }
        })
        .catch(e => console.log("error: " + e));
      }
    },
    handleFileUpload() {
      
      let tmp = this.$refs.file.files[0];

      if(tmp.name.endsWith(".bpmn") && tmp.type == ""){
        this.file = tmp;
      }
    },
    openCharacteristicDialog(item){
      this.$refs.newCharacteristics.open(item, false).then(res =>{
        this.characteristics = res;
        this.fileName = this.characteristics.name;
      }).catch(e => this.addCharacteristic = false)
    },
  }
};
</script>